/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useState } from "react";

import { useSimpleEvent } from "../../../../ui/hooks/useSimpleEvent";
import { ENDPOINT_EDITOR_VIEW_MODE, EndpointEditorEditView } from "../EndpointEditorEditView";
import { EndpointEditorEditDebug } from "./EndpointEditorEditDebug";
import { EndpointEditorEditFlow } from "./EndpointEditorEditFlow";

/**
 * Component props
 */
export interface IEndpointEditorMainContentProps {
	view: EndpointEditorEditView;
}

/**
 * Main Content Component
 *
 * @param props Component props
 */
export const EndpointEditorEditMainContent: React.FunctionComponent<IEndpointEditorMainContentProps> = ({
	view
}) => {
	const [ editorMode, setEditorMode ] = useState(() => view.getMode());

	useSimpleEvent(view.onModeChange, () => setEditorMode(view.getMode()), [ view ], true);

	switch (editorMode) {
		case ENDPOINT_EDITOR_VIEW_MODE.DESIGN:
			return <EndpointEditorEditFlow view={view} />;
		case ENDPOINT_EDITOR_VIEW_MODE.DEBUG:
			return <EndpointEditorEditDebug view={view} />;
	}
};
